import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || '';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// ============================================================
// EMPRESAS
// ============================================================
export const getEmpresas = () => api.get('/empresas');
export const createEmpresa = (data) => api.post('/empresas', data);
export const updateEmpresa = (id, data) => api.put(`/empresas/${id}`, data);

// ============================================================
// MONEDAS
// ============================================================
export const getMonedas = () => api.get('/monedas');

// ============================================================
// TIPO CAMBIO
// ============================================================
export const getTiposCambio = (monedaId) => api.get('/tipos-cambio', { params: { moneda_id: monedaId } });
export const getTCHoy = () => api.get('/tipos-cambio/hoy');
export const createTipoCambio = (data) => api.post('/tipos-cambio', data);

// ============================================================
// CATEGORÍAS
// ============================================================
export const getCategorias = (empresaId) => api.get('/categorias', { params: { empresa_id: empresaId } });
export const createCategoria = (data) => api.post('/categorias', data);
export const updateCategoria = (id, data) => api.put(`/categorias/${id}`, data);
export const deleteCategoria = (id) => api.delete(`/categorias/${id}`);

// ============================================================
// LÍNEAS DE NEGOCIO
// ============================================================
export const getLineasNegocio = (empresaId) => api.get('/lineas-negocio', { params: { empresa_id: empresaId } });
export const createLineaNegocio = (data) => api.post('/lineas-negocio', data);
export const updateLineaNegocio = (id, data) => api.put(`/lineas-negocio/${id}`, data);
export const deleteLineaNegocio = (id) => api.delete(`/lineas-negocio/${id}`);

// ============================================================
// CENTROS DE COSTO
// ============================================================
export const getCentrosCosto = (empresaId) => api.get('/centros-costo', { params: { empresa_id: empresaId } });
export const createCentroCosto = (data) => api.post('/centros-costo', data);
export const updateCentroCosto = (id, data) => api.put(`/centros-costo/${id}`, data);
export const deleteCentroCosto = (id) => api.delete(`/centros-costo/${id}`);

// ============================================================
// ARTÍCULOS
// ============================================================
export const getArticulos = (empresaId) => api.get('/articulos', { params: { empresa_id: empresaId } });
export const createArticulo = (data) => api.post('/articulos', data);
export const updateArticulo = (id, data) => api.put(`/articulos/${id}`, data);
export const deleteArticulo = (id) => api.delete(`/articulos/${id}`);

// ============================================================
// PROVEEDORES
// ============================================================
export const getProveedores = (empresaId) => api.get('/proveedores', { params: { empresa_id: empresaId } });
export const createProveedor = (data) => api.post('/proveedores', data);
export const updateProveedor = (id, data) => api.put(`/proveedores/${id}`, data);
export const deleteProveedor = (id) => api.delete(`/proveedores/${id}`);

// ============================================================
// CLIENTES
// ============================================================
export const getClientes = (empresaId) => api.get('/clientes', { params: { empresa_id: empresaId } });
export const createCliente = (data) => api.post('/clientes', data);
export const updateCliente = (id, data) => api.put(`/clientes/${id}`, data);
export const deleteCliente = (id) => api.delete(`/clientes/${id}`);

// ============================================================
// CUENTAS
// ============================================================
export const getCuentas = (empresaId) => api.get('/cuentas', { params: { empresa_id: empresaId } });
export const createCuenta = (data) => api.post('/cuentas', data);
export const updateCuenta = (id, data) => api.put(`/cuentas/${id}`, data);
export const deleteCuenta = (id) => api.delete(`/cuentas/${id}`);

// ============================================================
// COMPRAS (FACTURA_PROVEEDOR + GASTO)
// ============================================================
export const getCompras = (empresaId, tipoCompra, estado) => 
  api.get('/compras', { params: { empresa_id: empresaId, tipo_compra: tipoCompra, estado } });
export const getCompra = (id) => api.get(`/compras/${id}`);
export const createCompra = (data) => api.post('/compras', data);
export const updateCompra = (id, data) => api.put(`/compras/${id}`, data);
export const deleteCompra = (id) => api.delete(`/compras/${id}`);
export const addPagoToCompra = (id, data) => api.post(`/compras/${id}/pagos`, data);

// ============================================================
// CXP (CUENTAS POR PAGAR)
// ============================================================
export const getCxP = (empresaId, estado) => api.get('/cxp', { params: { empresa_id: empresaId, estado } });
export const getCxPDetail = (id) => api.get(`/cxp/${id}`);

// ============================================================
// LETRAS
// ============================================================
export const getLetras = (empresaId, cxpId, estado) => 
  api.get('/letras', { params: { empresa_id: empresaId, cxp_id: cxpId, estado } });
export const createLetra = (data) => api.post('/letras', data);
export const createMultiLetras = (data) => api.post('/letras/multi', data);
export const updateLetra = (id, data) => api.put(`/letras/${id}`, data);
export const deleteLetra = (id) => api.delete(`/letras/${id}`);
export const addPagoToLetra = (id, data) => api.post(`/letras/${id}/pagos`, data);

// ============================================================
// PAGOS
// ============================================================
export const getPagos = (empresaId, tipo) => api.get('/pagos', { params: { empresa_id: empresaId, tipo } });
export const createPago = (data) => api.post('/pagos', data);
export const deletePago = (id) => api.delete(`/pagos/${id}`);

// ============================================================
// TRABAJADORES
// ============================================================
export const getTrabajadores = (empresaId) => api.get('/trabajadores', { params: { empresa_id: empresaId } });
export const createTrabajador = (data) => api.post('/trabajadores', data);
export const updateTrabajador = (id, data) => api.put(`/trabajadores/${id}`, data);
export const deleteTrabajador = (id) => api.delete(`/trabajadores/${id}`);

// ============================================================
// MÓDULO DE PLANILLA - AFPs
// ============================================================
export const getAFPs = () => api.get('/afps');
export const createAFP = (data) => api.post('/afps', data);

// ============================================================
// MÓDULO DE PLANILLA - BANCOS
// ============================================================
export const getBancos = () => api.get('/bancos');
export const createBanco = (data) => api.post('/bancos', data);

// ============================================================
// MÓDULO DE PLANILLA - EMPLEADOS
// ============================================================
export const getEmpleados = (empresaId, activo = null) => api.get('/empleados', { params: { empresa_id: empresaId, activo } });
export const getEmpleado = (id) => api.get(`/empleados/${id}`);
export const createEmpleado = (data) => api.post('/empleados', data);
export const updateEmpleado = (id, data) => api.put(`/empleados/${id}`, data);
export const deleteEmpleado = (id) => api.delete(`/empleados/${id}`);

// ============================================================
// MÓDULO DE PLANILLA - CONCEPTOS
// ============================================================
export const getConceptosPlanilla = (empresaId, tipo = null) => api.get('/conceptos-planilla', { params: { empresa_id: empresaId, tipo } });
export const createConceptoPlanilla = (data) => api.post('/conceptos-planilla', data);

// ============================================================
// DASHBOARD / REPORTES
// ============================================================
export const getDashboard = (empresaId) => api.get('/dashboard', { params: { empresa_id: empresaId } });
export const getFlujoCaja = (empresaId, fechaInicio, fechaFin) => 
  api.get('/reportes/flujo-caja', { params: { empresa_id: empresaId, fecha_inicio: fechaInicio, fecha_fin: fechaFin } });
export const getCxPAging = (empresaId) => api.get('/reportes/cxp-aging', { params: { empresa_id: empresaId } });

export default api;

// Ordenes de Compra
export const getOrdenesCompra = (empresaId, estado) => api.get(`/ordenes-compra`, { params: { empresa_id: empresaId, estado } });
export const getOrdenCompra = (id) => api.get(`/ordenes-compra/${id}`);
export const createOrdenCompra = (data) => api.post(`/ordenes-compra`, data);
export const updateOrdenCompra = (id, data) => api.put(`/ordenes-compra/${id}`, data);
export const deleteOrdenCompra = (id) => api.delete(`/ordenes-compra/${id}`);
export const getSiguienteNumeroOC = (empresaId) => api.get(`/ordenes-compra/siguiente-numero/${empresaId}`);
